import { Component, computed, inject, linkedSignal, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, MatSidenavModule, HeaderComponent, SidebarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);

  isMobile = toSignal(
    this.breakpointObserver.observe('(max-width: 768px)').pipe(map(r => r.matches)),
    { initialValue: false },
  );

  sidenavMode = computed(() => (this.isMobile() ? ('over' as const) : ('side' as const)));
  sidenavOpen = linkedSignal(() => !this.isMobile());
  sidebarCollapsed = signal(localStorage.getItem('sidebar-collapsed') === 'true');
  showCollapsed = computed(() => !this.isMobile() && this.sidebarCollapsed());

  onSidebarExpandRequest(): void {
    this.sidebarCollapsed.set(false);
    localStorage.setItem('sidebar-collapsed', 'false');
  }

  handleMenuClick(): void {
    if (this.isMobile()) {
      this.sidenavOpen.update(v => !v);
    } else {
      const next = !this.sidebarCollapsed();
      this.sidebarCollapsed.set(next);
      localStorage.setItem('sidebar-collapsed', String(next));
    }
  }
}
